.modal {
  min-width: 600px;
  max-width: 700px;
}

.optionsRow {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 30px 0 40px 0;
}

.fullRow {
  display: flex;
  flex-direction: row;
  gap: 24px;
  justify-content: center;
}

.centeredRow {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.optionBox {
  flex: 1 1 0;
  min-width: 150px;
  max-width: 200px;
  border: 2px solid var(--gray-xl);
  border-radius: 10px;
  background: #fff;
  padding: 24px 12px 18px 12px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: border-color 0.2s, background 0.2s;
  position: relative;
}

.optionBox:hover {
  border-color: var(--blue-l);
}

.radioRow {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 10px;
}

.radio {
  width: 22px;
  height: 22px;
  border: 2px solid var(--gray-xl);
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.2s;
}

.radioSelected {
  background: #fff;
}
.radioSelected::after {
  content: '';
  width: 12px;
  height: 12px;
  background: var(--blue-l);
  border-radius: 50%;
}

.logo {
  margin: 10px 0 12px 0;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logoImg {
  width: 220px;
  height: auto;
  max-width: 80%;
  display: block;
  margin: 0 auto 12px auto;
  object-fit: contain;
}

.logoPlaceholder {
  width: 80px;
  height: 32px;
  background: var(--gray-xl);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--gray);
  font-size: 14px;
  border-radius: 4px;
}

.label {
  font-family: var(--font-semibold);
  font-size: 18px;
  text-align: center;
  margin-top: 4px;
}

.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  gap: 20px;
}

.bold {
  font-family: var(--font-bold);
}

.section {
  font-family: var(--font-bold);
  color: var(--gray-d);
}
